import { PracticeBatterSingleSessionContactPointChartConfigDto, ContactPointChartDataDto } from 'types/CodegenReportTypes';

import { ChartProps } from 'utilities/chartIdToComponent';
import {
  hitTypeToColor,
  hitTypeToTextColor,
  pitchTypeGroupTextToColor,
  pitchTypeGroupToColor,
  pitchTypeToColor,
  pitchTypeToTextColor,
} from 'utilities/colorHelpers';
import ContactPointChart from 'components/Charts/ContactPointChart/ContactPointChart';
import useReportStore from 'hooks/PracticeReport/BatterSingle/reportStore';
import { hitTypes, pitchTypeGroups, pitchTypes } from 'utilities/constants';

function getGroupLabelColor(groupLabel: string) {
  return pitchTypeToColor[groupLabel] ?? pitchTypeGroupToColor[groupLabel] ?? hitTypeToColor[groupLabel];
}

function getGroupLabelTextColor(groupLabel: string) {
  return pitchTypeToTextColor[groupLabel] ?? pitchTypeGroupTextToColor[groupLabel] ?? hitTypeToTextColor[groupLabel];
}

const PracticeBatterSingleSessionContactPointChart = ({
  chartData,
  isLoading,
  chartConfig,
}: ChartProps<ContactPointChartDataDto, PracticeBatterSingleSessionContactPointChartConfigDto>) => {
  const { selectedConfgValues } = useReportStore();

  return (
    <ContactPointChart
      chartData={chartData?.groups}
      showBufferZone={false}
      showStrikeZoneGrid={true}
      groupLabelsToSimulate={
        chartConfig.grouping === 'PitchTypeOrGroup'
          ? selectedConfgValues.pitchGrouping === 'Types'
            ? pitchTypes
            : pitchTypeGroups
          : hitTypes
      }
      getGroupLabelColor={getGroupLabelColor}
      getGroupLabelTextColor={getGroupLabelTextColor}
      isLoading={isLoading}
    />
  );
};

export default PracticeBatterSingleSessionContactPointChart;
